/**
 * react-store
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { shallow } from '@tanstack/store';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';

function useStore(store, selector = d => d, compareShallow) {
  const slice = useSyncExternalStoreWithSelector(store.subscribe, () => store.state, () => store.state, selector, compareShallow ? shallow : undefined);
  return slice;
}

export { useStore };
//# sourceMappingURL=index.js.map
